import { ref, onMounted } from 'vue'
import MembersService from '@/hotelcem/apis/configuration-center/members-management'
import store from '@/hotelcem/store/index'

export function useOrgTree(context) {
  const treeProps = ref({
    isLeaf: 'leaf',
  })

  let currentDep = ref({
    label: '',
    value: '',
  })
  let currentNodeKey = ref('')
  let showTree = ref(false)
  let defaultCheckedList = ref([])

  function loadTreeNode(node, resolve) {
    // 逐级加载组织树
    const { data } = node
    MembersService.getDeptAndHotel({
      deptUid: data?.value,
    }).then(res => {
      const nodes =
        res?.map(item => {
          return {
            label: item.deptName,
            value: item.deptUid,
            cityId: item.cityId || '',
            category: item.deptCategory,
            leaf: item.deptCategory === 2,
            hotelId: item.deptCode || '',
          }
        }) || []
      if ((!data || !data.value) && defaultCheckedList.value.length === 0 && nodes?.length > 0) {
        currentNodeKey.value = nodes[0].value
        currentDep.value = {
          label: nodes[0].label,
          value: nodes[0].value,
          category: nodes[0].category,
          hotelId: nodes[0].hotelId || '',
          cityId: nodes[0].cityId || '',
        }
        context.emit('orgTreeNodeClick', currentDep)
        commitDepId()
      }
      resolve(nodes)
    })
  }

  function orgTreeNodeClick(data) {
    currentDep.value = {
      label: data.label,
      value: data.value,
      category: data.category,
      hotelId: data.hotelId || '',
      cityId: data.cityId || '',
    }
    commitDepId()
    setLocalDepId(currentDep.value)
    showTree.value = false
    context.emit('orgTreeNodeClick', currentDep)
  }

  function commitDepId() {
    store.commit('common/SET_CURRENT_DEP_ID', currentDep.value.value)
    store.commit('common/SET_CURRENT_DEP_INFO', currentDep.value)
  }

  // 缓存选中的部门ID
  let account = (JSON.parse(localStorage.getItem('VOCUST_APP_BASE_ID')) || {}).userInfo?.account
  const localDepId = `LOCAL_DEP_ID_${account}`
  function setLocalDepId(val) {
    sessionStorage.setItem(localDepId, JSON.stringify(val))
  }
  function getLocalDepId() {
    return JSON.parse(sessionStorage.getItem(localDepId) || '{}')
  }

  onMounted(() => {
    let localDepId = getLocalDepId()
    if (!localDepId.value) {
      return
    }
    currentDep.value = Object.assign({
      label: '',
      value: '',
      ...localDepId,
    })
    context.emit('orgTreeNodeClick', currentDep)
    commitDepId()
    defaultCheckedList.value = [currentDep.value.value]
  })

  return { treeProps, currentDep, showTree, currentNodeKey, defaultCheckedList, loadTreeNode, orgTreeNodeClick }
}
